import styled from 'styled-components';

export const ViewerPage = styled.main`
  box-sizing: border-box;
  height: calc(100vh - 116px);
  padding: 12px 16px;
  background: aliceblue;
  display: flex;
  flex-direction: column;

  > h1 {
    margin: 0 0 2px;
    font-size: 24px;
  }

  > p {
    margin: 0 0 10px;
  }
`;

export const ViewerWorkspace = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  gap: 10px;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const StudyPanel = styled.aside`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 250px;
  flex: 0 0 250px;
  min-height: 0;
  align-self: stretch;
  border-radius: 12px;
  padding: 14px;
  background: #0c1724;
  box-shadow: 0 12px 30px rgba(16, 42, 67, 0.15);

  @media (max-width: 800px) {
    width: 100%;
    flex-basis: auto;
  }
`;

export const ReviewListSection = styled.section`
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  margin-top: 22px;
  color: white;
`;

export const StudyWarning = styled.div`
  margin-top: 12px;
  border: 1px solid rgba(255, 200, 87, 0.75);
  border-radius: 7px;
  padding: 9px 10px;
  background: rgba(255, 200, 87, 0.12);
  color: #ffe09a;
  font-size: 12px;
  line-height: 1.4;
`;

export const AnnotationSetOwner = styled.div`
  display: grid;
  gap: 2px;
  margin-top: 12px;
  color: white;

  span {
    color: rgba(255, 255, 255, 0.65);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  strong {
    overflow-wrap: anywhere;
    font-size: 13px;
  }
`;

export const ReviewListTitle = styled.h2`
  margin: 0 0 8px;
  font-size: 12px;
  letter-spacing: 0.04em;
`;

export const ReviewList = styled.div`
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
  padding-right: 4px;
`;

export const ReviewListGroup = styled.section`
  display: flex;
  flex-direction: column;
  gap: 5px;

  & + & {
    margin-top: 18px;
  }
`;

export const ReviewButton = styled.button<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  border: 1px solid;
  border-color: ${({ $active }) => ($active ? '#9ee6b8' : 'rgba(255, 255, 255, 0.24)')};
  border-radius: 6px;
  padding: 7px 8px;
  background: ${({ $active }) => ($active ? 'rgba(158, 230, 184, 0.2)' : 'transparent')};
  color: white;
  font: inherit;
  font-size: 12px;
  text-align: left;
  cursor: pointer;

  &:hover {
    border-color: rgba(255, 255, 255, 0.7);
  }

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ReviewType = styled.span`
  color: #9ee6b8;
  font-size: 10px;
  font-weight: 700;
`;

export const ReviewCardMessage = styled.p<{ $empty?: boolean }>`
  margin: 1px 0 0;
  color: ${({ $empty }) => ($empty ? 'rgba(255, 255, 255, 0.5)' : 'white')};
  font-size: 13px;
  font-weight: ${({ $empty }) => ($empty ? 400 : 700)};
  line-height: 1.35;
  overflow-wrap: anywhere;
`;

export const ReviewListMessage = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
`;

export const ViewerShell = styled.section`
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  border-radius: 12px;
  background: #0c1724;
  box-shadow: 0 12px 30px rgba(16, 42, 67, 0.2);

  > div[aria-label='Interactive 3D segmentation model'] {
    height: 100%;
  }

  canvas {
    display: block;
    width: 100%;
    height: 100%;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }
`;

export const FramePreviewPanel = styled.aside`
  position: absolute;
  z-index: 2;
  top: 68px;
  left: 16px;
  width: min(360px, 38%);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 10px;
  background: rgba(7, 18, 31, 0.96);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);
  color: white;
`;

export const FramePreviewHeader = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
  padding: 7px 9px;
`;

export const FramePreviewMetadata = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  min-width: 0;
  font-size: 11px;

  strong {
    flex: 1 1 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > span {
    min-width: 0;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > .segmentation-class {
    flex: 1 1 100%;
  }
`;

export const FramePreviewLink = styled.a`
  flex: 0 0 auto;
  color: #9ee6b8;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    color: white;
    text-decoration: underline;
  }
`;

export const FrameReviewButton = styled.button`
  flex: 0 0 auto;
  border: 1px solid #9ee6b8;
  border-radius: 6px;
  padding: 3px 6px;
  background: rgba(158, 230, 184, 0.16);
  color: #9ee6b8;
  font: inherit;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background: #9ee6b8;
    color: #102033;
  }
`;

export const FrameReviewForm = styled.form`
  display: grid;
  gap: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  padding: 10px 12px 12px;

  label {
    display: grid;
    gap: 5px;
    font-size: 12px;
    font-weight: 700;
  }

  textarea {
    box-sizing: border-box;
    width: 100%;
    min-height: 70px;
    resize: vertical;
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 6px;
    padding: 8px;
    background: rgba(255, 255, 255, 0.08);
    color: white;
    font: inherit;
    font-weight: 400;
  }

  p {
    margin: 0;
    color: #ffadad;
    font-size: 12px;
  }
`;

export const AnnotationOwnerChoices = styled.fieldset`
  display: grid;
  gap: 5px;
  min-width: 0;
  margin: 0;
  border: 0;
  padding: 0;

  legend {
    margin-bottom: 4px;
    padding: 0;
    font-size: 12px;
    font-weight: 700;
  }

  > span {
    color: rgba(255, 255, 255, 0.65);
    font-size: 11px;
  }
`;

export const AnnotationOwnerChoice = styled.label`
  display: flex !important;
  grid-template-columns: none !important;
  align-items: flex-start;
  gap: 6px !important;
  font-size: 11px !important;
  font-weight: 400 !important;
  cursor: pointer;

  input {
    flex: 0 0 auto;
    margin: 2px 0 0;
  }

  span {
    overflow-wrap: anywhere;
  }
`;

export const FrameReviewActions = styled.div`
  display: flex;
  gap: 7px;

  button {
    border: 1px solid rgba(255, 255, 255, 0.45);
    border-radius: 6px;
    padding: 6px 9px;
    background: transparent;
    color: white;
    font: inherit;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
  }

  button[type='submit'] {
    border-color: #9ee6b8;
    background: #9ee6b8;
    color: #102033;
  }

  button:disabled {
    cursor: wait;
    opacity: 0.65;
  }
`;

export const FramePreviewCloseButton = styled.button`
  border: 0;
  padding: 0 3px;
  background: transparent;
  color: white;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
`;

export const FramePreviewMedia = styled.div`
  position: relative;
  min-height: 180px;
  background: black;
`;

export const FramePreviewImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export const FramePreviewOverlay = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

export const FramePreviewMessage = styled.div`
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  text-align: center;
`;

export const TopBar = styled.div`
  position: absolute;
  z-index: 1;
  top: 16px;
  left: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;

export const StudyLabel = styled.button`
  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: 7px;
  padding: 8px 10px;
  background: rgba(7, 18, 31, 0.9);
  color: white;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.72;
  }

  &:not(:disabled):hover {
    border-color: #9ee6b8;
    color: #9ee6b8;
  }
`;

export const SegmentationLoadGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SegmentationPageCount = styled.span`
  color: rgba(255, 255, 255, 0.72);
  font-size: 11px;
  white-space: nowrap;
`;

export const StudySelector = styled.label`
  display: grid;
  gap: 4px;
  color: white;
  font-size: 12px;
  font-weight: 700;

  select {
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.55);
    border-radius: 7px;
    padding: 8px 10px;
    background: rgba(7, 18, 31, 0.9);
    color: white;
    font-size: 14px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ToggleButton = styled.button<{ $active: boolean; $color?: string }>`
  border: 1px solid ${({ $color }) => $color ?? 'rgba(255, 255, 255, 0.55)'};
  border-radius: 7px;
  padding: 7px 10px;
  background: ${({ $active, $color }) =>
    $active ? ($color ?? 'rgba(255, 255, 255, 0.85)') : 'rgba(7, 18, 31, 0.78)'};
  color: ${({ $active }) => ($active ? '#102033' : '#fff')};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition:
    opacity 0.15s ease,
    transform 0.15s ease;

  &:hover {
    opacity: 0.85;
  }

  &:active {
    transform: scale(0.97);
  }
`;

export const AnatomyBar = styled(ButtonGroup)`
  position: absolute;
  z-index: 1;
  bottom: 16px;
  left: 16px;
  right: 16px;
`;

export const Hint = styled.p`
  position: absolute;
  z-index: 1;
  right: 18px;
  bottom: 5px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 12px;
  pointer-events: none;
`;

export const Fallback = styled.div`
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  padding: 24px;
  pointer-events: none;
`;
